import { define } from "../preactement/define";
import { attributes } from "./shared-attributes";
import { StarIcon } from "../../Icons";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const starAttributes = [...attributes, 'is-filled'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    ariaHidden = 'true',
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(StarIcon, {
    ariaHidden: parseBooleanAttr(ariaHidden),
    ...otherProps
  });
};
define('ds-star-icon', () => Wrapper, {
  attributes: starAttributes
});